document.documentElement.classList.add('js');

document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-menu-toggle]');
  if (toggle) {
    const nav = document.querySelector('[data-mobile-nav]');
    const open = nav.toggleAttribute('data-open');
    toggle.setAttribute('aria-expanded', String(open));
  }
});

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-slider]').forEach((slider) => {
    const track = slider.querySelector('[data-slider-track]');
    slider.querySelector('[data-prev]')?.addEventListener('click', () => track.scrollBy({ left: -track.clientWidth * .8, behavior: 'smooth' }));
    slider.querySelector('[data-next]')?.addEventListener('click', () => track.scrollBy({ left: track.clientWidth * .8, behavior: 'smooth' }));
  });

  document.querySelectorAll('[data-commerce-hero]').forEach((hero) => {
    const slides = [...hero.querySelectorAll('[data-hero-slide]')];
    const dots = [...hero.querySelectorAll('[data-hero-dot]')];
    let current = 0;
    const show = (index) => {
      current = index;
      slides.forEach((slide, i) => slide.classList.toggle('is-active', i === index));
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === index));
    };
    dots.forEach((dot, i) => dot.addEventListener('click', () => show(i)));
    if (!window.matchMedia('(prefers-reduced-motion: reduce)').matches && slides.length > 1) {
      window.setInterval(() => show((current + 1) % slides.length), 6500);
    }
  });
});
